import firebase from 'firebase';
const firebaseConfig = {
  apiKey: "AIzaSyClM4HzVZbxUROBh3H52fUZNUWr4RmyCQU",
  authDomain: "whatsapp-clone-258f9.firebaseapp.com",
  databaseURL: "https://whatsapp-clone-258f9.firebaseio.com",
  projectId: "whatsapp-clone-258f9",
  storageBucket: "whatsapp-clone-258f9.appspot.com",
  messagingSenderId: "61426072078",
  appId: "1:61426072078:web:3336b3cd14de0bb4d45a5f",
  measurementId: "G-7K2T2D1S30"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

const auth = firebase.auth();

const provider = new firebase.auth.GoogleAuthProvider();

 export {auth, provider}
//export {auth}
export default db;

